// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Vrt-N","modalFooterButton":"ModalNotes_modalFooterButton__14l-R"};